import { render } from "./TermsCondition.vue?vue&type=template&id=60967c2b&scoped=true"
import script from "./TermsCondition.vue?vue&type=script&lang=js"
export * from "./TermsCondition.vue?vue&type=script&lang=js"

import "./TermsCondition.vue?vue&type=style&index=0&id=60967c2b&lang=scss&scoped=true"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60967c2b"]])

export default __exports__